export enum SessionTypeEnum {
  MAIN = "main",
  ARCHIVED = "archived",
}

export enum SessionRoleEnum {
  PUBLISHER = "publisher",
  MODERATOR = "moderator",
}
